/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const BackboneRadio = require('backbone.radio'),
    _ = require('lodash'),
    Marionette = require('backbone.marionette'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'console p-2 mb-2'
    },
    channels: {
        console: BackboneRadio.channel('console')
    },
    template: templates.console,
    //
    initialize: function () {
        this.listenTo(this.channels.console, 'log', _.bind(this.write, this));
    },
    write: function (msg, tee) {
        this.$el.append((typeof msg === 'string' ? msg : JSON.stringify(msg)) + '<br>').scrollTop(1000000);
        if (tee) {
            console.log(msg);
        }
    }
});

